module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.showCopyMenuModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Copy Menu")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage.length),
      expression: "errorMessage.length"
    }],
    ref: "errorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('select-locations-popup', {
    attrs: {
      "withButton": false,
      "exclude": [_vm.$root.activeLocation.id]
    },
    on: {
      "selectedLocations": _vm.updateLocations
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('label', [_vm._v("Replace existing?")]), _c('br'), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#0c6",
      "inactive-color": "#ff4949",
      "active-value": 1,
      "inactive-value": 0,
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.replaceExisting),
      callback: function($$v) {
        _vm.replaceExisting = $$v
      },
      expression: "replaceExisting"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn blue",
    on: {
      "click": function($event) {
        _vm.copyMenu()
      }
    }
  }, [_vm._v("Copy")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87638360"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MenuManager/Menus/CopyMenu.vue
// module id = 763
// module chunks = 0